import { render } from "./OurClientsPage.vue?vue&type=template&id=28118334"
import script from "./OurClientsPage.vue?vue&type=script&lang=js"
export * from "./OurClientsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/azai-web/azaitech-website-template-main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__